import { AxiosInstance } from 'axios'

import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'
import {
  CreateEmployeesSpouseRequest,
  UploadEmployeeMarriageCertificateRequest,
} from '@modules/employees/types/EmployeesSpouses/requests'

export class EmployeesSpousesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesSpouseRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/spouses`, body)

    return response.data
  }

  async uploadMarriageCertificate({ id, file }: UploadEmployeeMarriageCertificateRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('certificate', file)

    const response = await this.instance.post(`/companies/employees/${id}/spouses/marriage-certificate`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesSpousesService = (instance: AxiosInstance) => new EmployeesSpousesService(instance)
